<template>
  <div id="final-register">
    <div class="img-mask">
      <img src="@/assets/like.svg" width="77px" height="73px" />
    </div>
    <div class="text-content">
      <p>{{ $t("_REGISTER.THANKS_FOR_REGISTER") }}</p>
      <p>{{ $t("_REGISTER.UPLOAD_CERTIFICATE_MESSAGE") }}</p>
    </div>
    <button class="btn btn-upload">
      <input
        multiple
        type="file"
        id="upload-certificate"
        style="display: none; width: 100%"
        @change="save"
      />
      <label class="mb-0 cursor">
        <p class="mb-0 mr-1">{{ $t("_REGISTER.UPLOAD_FILE") }}</p>
      </label>
      <span class="icon icon-upload" style="font-size: 20px;"></span>
    </button>
    <span v-if="fileName" style="font-size: 12px">{{ fileName }}</span>
  </div>
</template>

<script>
import { service } from "@/_services/UploadFile/upload-file.service.js";
import { _alert } from "@/_helpers/function.js";
export default {
  data() {
    return {
      fileName: null
    };
  },
  mounted() {
    document.querySelector(".btn-upload").addEventListener("click", function() {
      document.getElementById("upload-certificate").click();
    });
  },
  watch: {
    fileName(value) {
      if (value) {
        document
          .querySelector(".btn-register-complete")
          .classList.add("btn-indigo");
        if (document.querySelector(".btn-register-complete"))
          document.querySelector(".btn-register-complete").disabled = false;
      } else {
        document
          .querySelector(".btn-register-complete")
          .classList.remove("btn-indigo");
        if (document.querySelector(".btn-register-complete"))
          document.querySelector(".btn-register-complete").disabled = true;
      }
    }
  },
  methods: {
    save() {
      const fileInput = document.querySelector("#upload-certificate");
      let formData = new FormData();
      let listFile = [...fileInput.files];
      let formatImage = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/gif",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ];
      let isValid = true;
      listFile.forEach(x => {
        if (!formatImage.includes(x.type)) {
          listFile.splice(listFile.indexOf(x), 1);
          this.$store.commit("alert/display", {
            message: this.$t("INVALID_FILE_FORMAT"),
            error: true,
            success: false
          });
          isValid = false;
        }
        if (x.size / (1024 * 1024) > 5) {
          this.$store.commit("alert/display", {
            message: this.$t("FILE_CAPACITY_NOT_BIGGER_THAN") + " 5MB",
            error: true,
            success: false
          });
          isValid = false;
        }
      });
      if (!isValid) {
        return false;
      }
      let promises = listFile.map(x => {
        formData = new FormData();
        formData.append("file", x);
        return service.uploadCetificate(formData);
      });
      promises.forEach((x, index) => {
        x.then(x => {
          _alert(x, this.$t(x.data), false);
          let symbol = this.fileName ? ", " : "";
          if (x.responseCode == 0) {
            this.fileName += symbol + listFile[0].name;
          } else {
            this.fileName = "";
          }
        }).catch(err => {
          // console.log(err);
        });
      });
    }
  }
};
</script>
